import { Container } from "@sembark-travel/ui-base"
import { Helmet } from "react-helmet-async"
import { NotificationPreferences } from "../../../Notifications"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { generatePath } from "../../../router-utils"

export default function NotificationPreferencesPage() {
	return (
		<>
			<Helmet>
				<title>Push Notifications</title>
			</Helmet>
			<Breadcrumbs
				title="Push Notifications"
				items={[
					[generatePath("/notifications"), "Notifications"],
					["", "Push Notifications"],
				]}
			/>
			<Container paddingY="4">
				<NotificationPreferences />
			</Container>
		</>
	)
}
